function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.49984 10.8334C7.96007 10.8334 8.33317 10.4603 8.33317 10C8.33317 9.5398 7.96007 9.16671 7.49984 9.16671C7.0396 9.16671 6.6665 9.5398 6.6665 10C6.6665 10.4603 7.0396 10.8334 7.49984 10.8334Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.49984 5.00004C7.96007 5.00004 8.33317 4.62694 8.33317 4.16671C8.33317 3.70647 7.96007 3.33337 7.49984 3.33337C7.0396 3.33337 6.6665 3.70647 6.6665 4.16671C6.6665 4.62694 7.0396 5.00004 7.49984 5.00004Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.49984 16.6667C7.96007 16.6667 8.33317 16.2936 8.33317 15.8334C8.33317 15.3731 7.96007 15 7.49984 15C7.0396 15 6.6665 15.3731 6.6665 15.8334C6.6665 16.2936 7.0396 16.6667 7.49984 16.6667Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4998 10.8334C12.9601 10.8334 13.3332 10.4603 13.3332 10C13.3332 9.5398 12.9601 9.16671 12.4998 9.16671C12.0396 9.16671 11.6665 9.5398 11.6665 10C11.6665 10.4603 12.0396 10.8334 12.4998 10.8334Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4998 5.00004C12.9601 5.00004 13.3332 4.62694 13.3332 4.16671C13.3332 3.70647 12.9601 3.33337 12.4998 3.33337C12.0396 3.33337 11.6665 3.70647 11.6665 4.16671C11.6665 4.62694 12.0396 5.00004 12.4998 5.00004Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4998 16.6667C12.9601 16.6667 13.3332 16.2936 13.3332 15.8334C13.3332 15.3731 12.9601 15 12.4998 15C12.0396 15 11.6665 15.3731 11.6665 15.8334C11.6665 16.2936 12.0396 16.6667 12.4998 16.6667Z",
  stroke: "currentColor",
  strokeWidth: 1.45833,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.03d6d157.svg";
export { ForwardRef as ReactComponent };